/**
 * Construye parámetros de paginación para la API
 * @param {number} pageIndex - Índice de página actual (1-based)
 * @param {Array} pageKeys - Array de claves de paginación
 * @param {number} pageSize - Tamaño de página
 * @returns {Object} Parámetros de paginación
 */
export function buildPaginationParams(pageIndex, pageKeys, pageSize) {
  const params = {
    limit: pageSize
  };
  
  // Agregar paginación backend si no es la primera página
  if (pageIndex > 1) {
    const previousPageKey = pageKeys[pageIndex - 2];
    if (previousPageKey) {
      params.startKey = previousPageKey.startKey;
      params.timestampFrom = previousPageKey.timestampFrom;
    }
  }
  
  return params;
}

/**
 * Construye parámetros de filtros para la API
 * @param {string|null} supervisor - Supervisor seleccionado
 * @param {Array} agents - Agentes seleccionados
 * @param {Object} dateRange - Rango de fechas
 * @returns {Object} Parámetros de filtros
 */
export function buildFilterParams(supervisor, agents, dateRange) {
  const params = {};
  
  if (dateRange?.startDate && dateRange?.endDate) {
    params.startDate = dateRange.startDate;
    params.endDate = dateRange.endDate;
  }
  
  if (supervisor) {
    params.supervisor = supervisor;
  }
  
  if (agents && agents.length > 0) {
    params.agent = agents;
  }
  
  return params;
}

/**
 * Construye parámetros completos para las APIs de resumen
 * @param {Object} baseParams - Parámetros base (fechas, filtros, etc.)
 * @param {Object} options - Opciones adicionales
 * @param {string} options.summaryName - Nombre del resumen (opcional)
 * @param {Array} options.selectedJobNames - Job names seleccionados (opcional)
 * @param {string|null} options.supervisor - Supervisor seleccionado (opcional)
 * @param {Array} options.agents - Agentes seleccionados (opcional)
 * @param {boolean} options.includeSelectedJobNames - Si incluir job names seleccionados (default: true)
 * @returns {Object} Parámetros completos
 */
export function buildSummaryParams(baseParams, options = {}) {
  const params = { ...baseParams };
  
  const {
    summaryName,
    selectedJobNames = [],
    supervisor,
    agents = [],
    includeSelectedJobNames = true
  } = options;
  
  // Agregar nombre del resumen si está presente
  if (summaryName && summaryName.trim()) {
    params.summaryName = summaryName.trim();
  }
  
  // Si hay items seleccionados, incluir sus jobNames
  if (includeSelectedJobNames && selectedJobNames.length > 0) {
    params.selectedJobNames = selectedJobNames.filter(jobName => jobName);
  }
  
  // Manejar supervisor (string) y agentes (array) solo si no hay selección específica
  if (selectedJobNames.length === 0) {
    if (supervisor) {
      params.supervisor = supervisor; // String único
    }
    
    if (agents.length > 0) {
      params.agent = agents; // Array
    }
  }
  
  return params;
}

